/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Toast_Update_In_InfoInputs */

const vi_scl_toast_update_in_info = /** @type {(inputs: Scl_Toast_Update_In_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật thông tin phiếu`)
};

/**

* @param {Scl_Toast_Update_In_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_toast_update_in_info = /** @type {((inputs?: Scl_Toast_Update_In_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Toast_Update_In_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_toast_update_in_info(inputs)
});